import { cuverseApi } from 'store/api/cuverse-api/cuverse.api';

import { DashboardRoute } from './dashboard.route';

export const requestDashboard = async (): Promise<unknown> =>
  cuverseApi.get(DashboardRoute.DashboardWallet()).then((res) => {
    return res?.data;
  });

export const requestElectricity = async (): Promise<unknown> =>
  cuverseApi.get(DashboardRoute.DashboardElectricity()).then((res) => {
    return res?.data;
  });

export const requestHashRate = async (): Promise<unknown> =>
  cuverseApi.get(DashboardRoute.DashboardMiningHashRate()).then((res) => {
    return res?.data;
  });

export const requestMiningTotal = async (): Promise<unknown> =>
  cuverseApi.get(DashboardRoute.DashboardMiningTotal()).then((res) => {
    return res?.data;
  });
